import { Pricing, PricingHeader as Header, Footer } from "../../components";

const PricingPage = () => {
    return (
        <>
            <Header />
            <Pricing />
            <Footer />
        </>
    );
}

export { PricingPage };